import React, { useState, useEffect, useContext } from "react";
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import AddIcon from '@material-ui/icons/Add';

import withWidth from '@material-ui/core/withWidth';

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';


import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';

import { DatePicker, TimePicker } from '../components/DatePicker';

import { API } from 'aws-amplify';
import { FullWidthTextField } from '../components/FullWidthTextField'
import CircularProgress from '@material-ui/core/CircularProgress';
import LoadingDialog from './LoadingDialog';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import DeleteIcon from '@material-ui/icons/Delete';

import LoadingButton from '../components/LoadingButton';

const options = { weekday: 'short', month: 'numeric', day: 'numeric', year:'numeric' };

const useStyles = makeStyles((theme) => ({
  dayEntry: {

  },
  paper: {
    height: '100%',
    padding: theme.spacing(0, 1),
    overflowY: 'hidden'
  },
  paperContent: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  iconRight: {
    position: 'absolute',
    right: '0px'
  },
  saveButton: {
    margin: theme.spacing (1),
  },
  root: {
    padding: theme.spacing(3)
  },
  datePicker: {
    width: '100%'
  },
  card: {
    height: '100%'
  }
}))

const todayTime = (h, m) => {
  const date = new Date;
  date.setHours (h, m, 0, 0);
  return date;
}

const Overview = () => {
  const classes = useStyles();
  const [initialized, setInitialized] = useState(false);
  const [entries, setEntries] = useState([])
  const [ open, setOpen ] = useState(false);
  const [ isLoading, setLoading ] = useState(false);
  

  const openDialog = () => {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false)
  }

  const onAdd = async (data) => {
    setLoading (true)
    const vac = await API.post ('appointments', '/vacation', {
      body: data
    });
    const res = await API.get ('appointments', '/vacation');
    setEntries(res);
    setLoading(false);
    setOpen(false)
  }

  useEffect (() => {
    if (!initialized)
    (async() => {
      const res = await API.get ('appointments', '/vacation');
      setInitialized(true);
      setEntries(res);
    })()
  })

  if (!initialized) {
    return <LoadingDialog>Urlaube werden geladen</LoadingDialog>
  }

  if (entries.length == 0) {
    return <>
    <Paper>
      <List>
        <ListItem>
          <ListItemText primary="Bislang wurden keine Urlaube geplant"/>
        </ListItem>
      </List>
    </Paper>
    <center>
      <Button variant="contained" color="primary" className={classes.saveButton} onClick={openDialog}>Urlaub planen</Button>  
    </center>
    <VacationPickerDialog isLoading={isLoading} open={open} onClose={handleClose} onAdd={onAdd}/>
    </>
  }

  return <>
  <Paper>
    <List>
      {entries.map ((entry) => {
          return <VacEntry setEntries={setEntries} entry={entry} />
      })}
    </List>
  </Paper>
  <center>
    <Button variant="contained" color="primary" className={classes.saveButton} onClick={openDialog}>Urlaub planen</Button>  
  </center>
  <VacationPickerDialog open={open} onClose={handleClose} onAdd={onAdd} isLoading={isLoading}/>
  </>
  
}

const VacEntry = (props) => {
  const { entry, setEntries } = props
  const fromD = new Date (entry.from);
  const toD = new Date (entry.to);
  const fromStr = fromD.toLocaleDateString('de-DE', options);
  const toStr = toD.toLocaleDateString('de-DE', options);
  
  const [isDeleting, setDeleting ] = useState(false);

  const handleDelete = async (entry) => {
    setDeleting (true);
    const vac = await API.del ('appointments', `/vacation/${entry.id}`);
    const res = await API.get ('appointments', '/vacation');
    setDeleting (false);
    setEntries(res);
  }

  return <ListItem>
        <ListItemText primary={`${fromStr} - ${toStr}`}></ListItemText>
        <ListItemSecondaryAction>
          <IconButton onClick={() => {
            handleDelete (entry);
          }}>
            {isDeleting?<CircularProgress size={20} />:<DeleteIcon />}
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
}
const VacationPickerDialog = (props) => {
  const { open, onAdd, day, onClose, isLoading} = props;
  return <Dialog open={open} onClose={onClose}>
    <VacationForm onAdd={onAdd} isLoading={isLoading}></VacationForm>
  </Dialog>
}

const VacationForm = (props) => {
  const classes = useStyles();
  const [ fromDate, setFrom ] = useState(new Date(todayTime(0, 0)));
  const [ toDate, setTo ] = useState(new Date(todayTime(24, 0)));
  const { onAdd, isLoading} = props;

  const handleSubmit = (e) => {
    e.preventDefault()
    if (typeof onAdd === 'function') {
      onAdd ({
        from: +fromDate,
        to: +toDate,
      })
    }
  }

  return <Card className={classes.card}>
        <CardContent>
          <Grid container justify="space-between" spacing={1}>
            <DatePicker className={classes.datePicker} label="Von" value={fromDate} onChange={setFrom} />
            <DatePicker className={classes.datePicker} label="Bis" value={toDate} onChange={setTo} />
          </Grid>
        </CardContent>
        <CardActions>
          <LoadingButton variant="contained" color="primary" isLoading={isLoading} type="submit" onClick={handleSubmit}>Hinzufügen</LoadingButton>
        </CardActions>
      </Card>
}
export default Overview;